import React from 'react'
import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import DescBanner from '../shared/DescBanner'
import Footer from '../Footer/footer'

import img1 from '../assets/images/ARNISI/WebP/1.webp'
import img2 from '../assets/images/ARNISI/WebP/2.webp'
import img3 from '../assets/images/ARNISI/WebP/3.webp'
import img4 from '../assets/images/ARNISI/WebP/4.webp'
import img5 from '../assets/images/ARNISI/WebP/5.webp'
import img6 from '../assets/images/ARNISI/WebP/6.webp'
import img7 from '../assets/images/ARNISI/WebP/7.webp'
import img8 from '../assets/images/ARNISI/WebP/8.webp'
import img9 from '../assets/images/ARNISI/WebP/9.webp'
import img10 from '../assets/images/ARNISI/WebP/10.webp'
import img11 from '../assets/images/ARNISI/WebP/11.webp'
import img12 from '../assets/images/ARNISI/WebP/12.webp'

import img01 from '../assets/images/Endi Coffee & Bakery Shop/WebP/0.webp'
import img02 from '../assets/images/Endi Coffee & Bakery Shop/WebP/1.webp'
import img03 from '../assets/images/Endi Coffee & Bakery Shop/WebP/2.webp'
import img04 from '../assets/images/Endi Coffee & Bakery Shop/WebP/3.webp'
import img05 from '../assets/images/Endi Coffee & Bakery Shop/WebP/4.webp'
import img06 from '../assets/images/Endi Coffee & Bakery Shop/WebP/5.webp'
import img07 from '../assets/images/Endi Coffee & Bakery Shop/WebP/6.webp'
import img08 from '../assets/images/Endi Coffee & Bakery Shop/WebP/7.webp'

import img111 from '../assets/images/VM INTERIOR/WebP/1.webp'
import img112 from '../assets/images/VM INTERIOR/WebP/2.webp'
import img13 from '../assets/images/VM INTERIOR/WebP/3.webp'
import img14 from '../assets/images/VM INTERIOR/WebP/4.webp'
import img15 from '../assets/images/VM INTERIOR/WebP/5.webp'
import img16 from '../assets/images/VM INTERIOR/WebP/6.webp'
import img17 from '../assets/images/VM INTERIOR/WebP/7.webp'
import img18 from '../assets/images/VM INTERIOR/WebP/8.webp'
import img19 from '../assets/images/VM INTERIOR/WebP/9.webp'
import img20 from '../assets/images/VM INTERIOR/WebP/10.webp'
import img21 from '../assets/images/VM INTERIOR/WebP/11.webp'

import img221 from '../assets/images/Restaurant/WebP/1.webp'
import img222 from '../assets/images/Restaurant/WebP/2.webp'
import img23 from '../assets/images/Restaurant/WebP/3.webp'
import img24 from '../assets/images/Restaurant/WebP/4.webp'
import img25 from '../assets/images/Restaurant/WebP/5.webp'
import img26 from '../assets/images/Restaurant/WebP/6.webp'
import img27 from '../assets/images/Restaurant/WebP/7.webp'
import img28 from '../assets/images/Restaurant/WebP/8.webp'
import img29 from '../assets/images/Restaurant/WebP/9.webp'

import CarouselModule from '../shared/Carousel'

const data = [
  {img:img1},
  {img:img2},
  {img:img3},
  {img:img4},
  {img:img5},
  {img:img6},
  {img:img7},
  {img:img8},
  {img:img9},
  {img:img10},
  {img:img11},
  {img:img12},
]

const data1 = [
  {img:img01},
  {img:img02},
  {img:img03},
  {img:img04},
  {img:img05},
  {img:img06},
  {img:img07},
  {img:img08},
]

const data2 = [
  {img:img111},
  {img:img112},
  {img:img13},
  {img:img14},
  {img:img15},
  {img:img16},
  {img:img17},
  {img:img18},
  {img:img19},
  {img:img20},
  {img:img21},
]

const data3 = [
  {img:img221},
  {img:img222},
  {img:img23},
  {img:img24},
  {img:img25},
  {img:img26},
  {img:img27},
  {img:img28},
  {img:img29},
]

export default function Projects() {
  return (
    <div className=''>
      <Navbar/>
      <TittleBanner img="bg-about-us-banner"  tiitle="PROJECTS" />

      <DescBanner text="At Arcium Studio, every project tells a story of thoughtful design, precision, and creativity. Our portfolio showcases a diverse range of residential, commercial, and interior projects, each crafted to reflect our clients’ vision and functional needs.
      From concept to completion, we approach every project with attention to detail, innovation, and a strong focus on quality. We believe great architecture balances aesthetics with purpose, resulting in spaces that are both inspiring and practical.
      Explore our projects and discover how we transform ideas into meaningful, lasting spaces."/>

    
      <div className='flex flex-col lg:flex-row items-center w-full justify-center'>
         <div className="flex items-center lg:items-left w-full lg:w-1/2 justify-center lg:justify-left text-center lg:text-left bg-blue-600 p-8 md:p-12 lg:px-16 lg:py-24">
            <div className="flex flex-col justify-left items-left">
              <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-4xl font-bold text-white">
              ADH INTERIOR
              </h2>
              <p className="mt-8 text-white/90">
                In the heart of Pristina, Arcium Studio designed a serene 85 m² private apartment that balances modern elegance with everyday comfort. Created for a client who values quality and harmony, the space is defined by warm wood tones and transparent glass, fostering a natural, light-filled atmosphere.
                The open-plan living area seamlessly connects the kitchen, dining, and lounge, creating a fluid and inviting environment. Two thoughtfully designed bedrooms offer comfort and functionality—the master featuring a bold velvet headboard and built-in storage, and the children’s room incorporating practical yet playful elements.
                With clean contemporary lines, neutral tones, warm wood accents, and integrated lighting, this project reflects Arcium Studio’s vision of creating timeless, livable spaces that feel both refined and welcoming.               </p>
            </div>
         </div>
        <div className='flex justify-center items-center w-full lg:w-3/5'>
            <CarouselModule data={data} tittle=""/>
        </div>
      </div>
      
      <div className='flex flex-col lg:flex-row items-center w-full justify-center'>
         <div className="flex items-center lg:items-left w-full lg:w-1/2 justify-center lg:justify-left text-center lg:text-left bg-blue-600 p-8 md:p-12 lg:px-16 lg:py-24">
            <div className="flex flex-col justify-left items-left">
              <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-4xl font-bold text-white">
              Endi Coffee & Bakery Shop
              </h2>
              <p className="mt-8 text-white/90">
                Designed by Arcium Studio, Endi Coffee & Bakery Shop blends traditional charm with contemporary elegance in the heart of Gjilan. Large arched windows inspired by local architecture flood the space with natural light, while warm wood elements, artisanal seating, and black iron details create a balance between heritage and modern design.
                Glass surfaces connect the interior with the lively streets outside, while spherical lighting, green plants, and colorful terrazzo flooring add warmth, freshness, and character. More than a café, Endi is a welcoming space that reflects the spirit of Gjilan—crafted to be experienced, enjoyed, and remembered.
              </p>
            </div>
         </div>
        <div className='flex justify-center items-center w-full lg:w-3/5'>
            <CarouselModule data={data1} tittle=""/>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row items-center w-full justify-center'>
         <div className="flex items-center lg:items-left w-full lg:w-1/2 justify-center lg:justify-left text-center lg:text-left bg-blue-600 p-8 md:p-12 lg:px-16 lg:py-24">
            <div className="flex flex-col justify-left items-left">
              <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-4xl font-bold text-white">
                  VM INTERIOR
              </h2>
              <p className="mt-8 text-white/90">Private Apartment – Pristina Interior design by Arcium Studio
                In a quiet area of Pristina, Arcium Studio designed a warm and inviting home where comfort meets simplicity. Natural light flows through the open space, highlighting herringbone wooden floors and solid wood furniture that add timeless character.
                The kitchen blends matte white cabinetry with wooden countertops and subtle gray tiles, while the living area offers a cozy retreat with a modular sofa, soft textures, and touches of greenery. Thoughtfully designed and effortlessly elegant, this apartment reflects Arcium Studio’s vision of creating spaces where minimalism and human warmth coexist. 
              </p>
            </div>
         </div>
        <div className='flex justify-center items-center w-full lg:w-3/5'>
            <CarouselModule data={data2} tittle=""/>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row items-center w-full justify-center'>
         <div className="flex items-center lg:items-left w-full lg:w-1/2 justify-center lg:justify-left text-center lg:text-left bg-blue-600 p-8 md:p-12 lg:px-16 lg:py-24">
            <div className="flex flex-col justify-left items-left">
              <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-4xl font-bold text-white">
              ENDI RESTAURANT
              </h2>
              <p className="mt-8 text-white/90">
                The interior of Endi Restaurant was conceived and designed by Arcium Studio, reflecting a modern and well-balanced architectural approach. The project is defined by clean lines, a clear spatial composition, and a functional organization of the space, specifically tailored to the needs of a restaurant environment.
                Natural materials such as wood are combined with metal and ceramic, creating a controlled contrast and a contemporary architectural identity. Panels with varied architectural designs add visual rhythm and depth to the interior.
                Custom-designed lighting is integrated as an architectural element, highlighting forms, materials, and the overall spatial structure. A palette of natural tones contributes to a calm, harmonious, and aesthetically refined atmosphere.
                The project is located along the main road connecting Gjilan and Ferizaj, representing a modern architectural intervention within its urban context.
              </p>
            </div>
         </div>
        <div className='flex justify-center items-center w-full lg:w-3/5'>
            <CarouselModule data={data3} tittle=""/>
        </div>
      </div>

      <Footer/>
    </div>
  )
}
